<div class="content-wrapper">
  @if (vehicles()) {
    <mat-card class="content">
      <div class="content-header">
        <h2>
          {{ showInactive() ? 'Inactieve' : 'Actieve' }} voertuigen
          <span>({{ filteredVehicles().length }})</span>
        </h2>
        <div class="header-right">
          <mat-form-field class="mat-form-field-no-subscript">
            <mat-label>Zoeken</mat-label>
            <input matInput autocomplete="off" placeholder="Zoeken" [formControl]="searchCtrl" />
            <button
              mat-icon-button
              matSuffix
              aria-label="Zoekopdracht wissen"
              (click)="clearSearch(); $event.stopPropagation()"
            >
              <mat-icon>clear</mat-icon>
            </button>
          </mat-form-field>
          <button
            mat-icon-button
            [attr.aria-label]="showInactive() ? 'Actieve voertuigen tonen' : 'Inactieve voertuigen tonen'"
            [matTooltip]="showInactive() ? 'Laat actieve voertuigen zien' : 'Laat inactieve voertuigen zien'"
            (click)="toggleStatusView(); $event.stopPropagation()"
          >
            <mat-icon>{{ showInactive() ? 'visibility_off' : 'visibility' }}</mat-icon>
          </button>
        </div>
      </div>
      <mat-table mat-table #table [dataSource]="filteredVehicles()">
        <!-- Name Column -->
        <ng-container matColumnDef="name">
          <mat-header-cell *matHeaderCellDef>Naam</mat-header-cell>
          <mat-cell *matCellDef="let vehicle">
            @if (vehicle.name) {
              <div class="text-truncate">
                {{ vehicle.name }}
              </div>
            }
          </mat-cell>
        </ng-container>
        @if (usesPrivateVehicles) {
          <ng-container matColumnDef="vehicleType">
            <mat-header-cell *matHeaderCellDef>Type</mat-header-cell>
            <mat-cell *matCellDef="let vehicle">
              {{ vehicle.vehicleType === 'private' ? 'Privé' : 'Organisatie' }}
            </mat-cell>
          </ng-container>
        }
        <!-- seats Column -->
        <ng-container matColumnDef="seats">
          <mat-header-cell *matHeaderCellDef>Zitplaatsen</mat-header-cell>
          <mat-cell *matCellDef="let vehicle">
            @if (vehicle.seats) {
              <div class="text-truncate">
                {{ vehicle.seats }}
              </div>
            }
          </mat-cell>
        </ng-container>
        <!-- sortingNumber Column -->
        <ng-container matColumnDef="sortingNumber">
          <mat-header-cell class="hide-column-3" *matHeaderCellDef>Volgordenummer</mat-header-cell>
          <mat-cell class="hide-column-3" *matCellDef="let vehicle">
            <div class="text-truncate">
              {{ vehicle.calendarStyle.sortingNumber ?? '-' }}
            </div>
          </mat-cell>
        </ng-container>
        <!-- mileage Column -->
        <ng-container matColumnDef="currentMileage">
          <mat-header-cell class="hide-column-4" *matHeaderCellDef>Kilometerstand</mat-header-cell>
          <mat-cell class="hide-column-4" *matCellDef="let vehicle">
            @if (vehicle.currentMileage !== null && vehicle.currentMileage !== undefined) {
              <div class="text-truncate">
                {{ vehicle.currentMileage }}
              </div>
            }
          </mat-cell>
        </ng-container>
        <!-- color Column -->
        <ng-container matColumnDef="color">
          <mat-header-cell class="hide-column-2" *matHeaderCellDef>Auto kleur</mat-header-cell>
          <mat-cell class="hide-column-2" *matCellDef="let vehicle">
            <div class="color-dot" [ngStyle]="{ 'background-color': vehicle.calendarStyle.color }"></div>
            <div class="text-truncate">
              {{ vehicle.calendarStyle.color }}
            </div>
          </mat-cell>
        </ng-container>
        <!-- colorEmpty Column -->
        <ng-container matColumnDef="backgroundColorEmpty">
          <mat-header-cell class="hide-column" *matHeaderCellDef>Rit leeg kleur</mat-header-cell>
          <mat-cell class="hide-column" *matCellDef="let vehicle">
            <div
              class="color-dot"
              [ngStyle]="{
                'background-color': vehicle.calendarStyle.backgroundColorEmpty,
              }"
            ></div>
            <div class="text-truncate">
              {{ vehicle.calendarStyle.backgroundColorEmpty }}
            </div>
          </mat-cell>
        </ng-container>
        <!-- colorFull Column -->
        <ng-container matColumnDef="backgroundColorFull">
          <mat-header-cell class="hide-column" *matHeaderCellDef>Rit vol kleur</mat-header-cell>
          <mat-cell class="hide-column" *matCellDef="let vehicle">
            <div
              class="color-dot"
              [ngStyle]="{
                'background-color': vehicle.calendarStyle.backgroundColorFull,
              }"
            ></div>
            <div class="text-truncate">
              {{ vehicle.calendarStyle.backgroundColorFull }}
            </div>
          </mat-cell>
        </ng-container>
        <!-- colorEmptyDriver Column -->
        @if (showDriverPlanning && !ignoreDriverStatus) {
          <ng-container matColumnDef="backgroundColorNoDriver">
            <mat-header-cell class="hide-column" *matHeaderCellDef>Geen chauffeur kleur</mat-header-cell>
            <mat-cell class="hide-column" *matCellDef="let vehicle">
              <div
                class="color-dot"
                [ngStyle]="{
                  'background-color': vehicle.calendarStyle.backgroundColorNoDriver ?? '#efefef',
                }"
              ></div>
              <div class="text-truncate">
                {{ vehicle.calendarStyle.backgroundColorNoDriver ?? '#efefef' }}
              </div>
            </mat-cell>
          </ng-container>
        }
        <!-- button Column -->
        <ng-container matColumnDef="button">
          <mat-header-cell *matHeaderCellDef></mat-header-cell>
          <mat-cell *matCellDef="let vehicle">
            <div class="buttons">
              <button mat-icon-button aria-label="Voertuig bewerken">
                <mat-icon>edit</mat-icon>
              </button>
            </div>
          </mat-cell>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
        <tr
          mat-row
          [ngClass]="{ 'row-inactive': !vehicle.active }"
          *matRowDef="let vehicle; columns: displayedColumns"
          role="button"
          tabindex="0"
          aria-label="Voertuig openen"
          (click)="editItem(vehicle)"
          (keydown.enter)="editItem(vehicle)"
          (keydown.space)="$event.preventDefault(); editItem(vehicle)"
          matRipple
        ></tr>
      </mat-table>
    </mat-card>
  } @else {
    <div class="content-spinner">
      <mat-spinner></mat-spinner>
    </div>
  }
</div>
